import Konva from 'konva';
import React from 'react';
import { Circle, Group } from 'react-konva';
import { MapInteractiveZone, SpotShape } from '../../../../types';
import { useMapCanvas } from '../../contexts/MapCanvasContext';
import {
  DEFAULT_NODE_CIRCLE_RADIUS,
  DEFAULT_NODE_CIRCLE_STROKE_WIDTH,
  DEFAULT_NODE_RECT_COLOR
} from '../../defines';
import { SpotLayout } from '../../types';
import { CircleProfilePhoto } from './CircleProfilePhoto';
import { getInteractiveZoneStyles } from './helpers';

export interface InteractiveZoneProps {
  shape: SpotShape;
  layout: SpotLayout;
  interactiveZone?: MapInteractiveZone;
  onClick: (event: Konva.KonvaEventObject<PointerEvent>) => void;
  onMouseEnter?: (event: Konva.KonvaEventObject<PointerEvent>) => void;
  onMouseLeave?: (event: Konva.KonvaEventObject<PointerEvent>) => void;
  selectIndex?: number;
  isActive?: boolean;
}

export const InteractiveZone: React.FC<InteractiveZoneProps> = ({
  shape,
  layout,
  interactiveZone,
  onClick,
  onMouseEnter,
  onMouseLeave,
  selectIndex,
  isActive
}) => {
  const { isPrivacyMode, authenticatedUser, hoveringNode } = useMapCanvas();
  const assignedUser = interactiveZone?.assignedUser || null;
  const actualSchedule = interactiveZone?.actualSchedule || null;

  const circleStyle = getInteractiveZoneStyles({
    isSelected: interactiveZone?.isSelected || false,
    isLastAccessed: interactiveZone?.isLastUsed || false,
    disabled: interactiveZone?.disabled || false,
    notAssignedResource: interactiveZone?.notAssigned || false,
    notAssignedUser: !assignedUser,
    requiresApproval: interactiveZone?.requiresApproval || false,
    hasSchedules: interactiveZone?.hasSchedules || false,
    showCircleProfilePhoto: interactiveZone?.showCircleProfilePhoto || false,
    hasCheckedIn: interactiveZone?.actualSchedule?.has_checked_in || false
  });

  const circleStrokeWidth =
    shape.circleProps?.strokeWidth ||
    //circleStyle.strokeWidth ||
    DEFAULT_NODE_CIRCLE_STROKE_WIDTH;
  const circleRadius = shape.circleProps?.radius || DEFAULT_NODE_CIRCLE_RADIUS;

  const circleColor =
    selectIndex !== undefined
      ? '#2563eb'
      : hoveringNode?.id === shape.id
        ? '#828383'
        : circleStyle.fill;

  return (
    <Group opacity={circleStyle.fillOpacity}>
      <Circle
        id={`shape-${shape.id}-circle`}
        x={layout.circle.x}
        y={layout.circle.y}
        radius={circleRadius}
        fill={
          isActive
            ? circleColor
            : shape.isInactive
              ? shape.rectProps?.color || DEFAULT_NODE_RECT_COLOR
              : 'grey'
        }
        stroke={circleStyle.stroke}
        strokeWidth={circleStrokeWidth}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onTap={onClick}
        perfectDrawEnabled={false}
      />
      {assignedUser ? (
        <CircleProfilePhoto
          privacy={
            isPrivacyMode && assignedUser.id !== authenticatedUser?.user?.id
          }
          profilePhoto={interactiveZone?.assignedUser?.profile_photo_url || ''}
          radius={circleRadius - circleStrokeWidth / 2}
          layout={layout}
          name={assignedUser.name || ''}
          restricted={true}
        />
      ) : null}
      {interactiveZone?.showCircleProfilePhoto ? (
        <CircleProfilePhoto
          privacy={
            isPrivacyMode &&
            actualSchedule?.user.id !== authenticatedUser?.user?.id
          }
          profilePhoto={actualSchedule?.user.profile_photo_url ?? ''}
          radius={circleRadius - circleStrokeWidth / 2}
          layout={layout}
          name={actualSchedule?.user.name || ''}
        />
      ) : null}
    </Group>
  );
};
